import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"color":"inherit"} }
const _hoisted_2 = { class: "py-3 text-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  class: "py-3 px-5",
  style: {"font-size":"0.875rem"}
}
const _hoisted_5 = { class: "d-flex w-100 p-3" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Aceptar ")

import Modal from "@/components/Modal.vue";
import { NotificationModule } from "@/store/modules/Notification";
import { computed, ref, watch } from "vue";

//State data

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const cancel = ref(false);

// computed
const show = computed(() => NotificationModule.showing);
const notification = computed(() => NotificationModule.notification);
const loading = computed(() => NotificationModule.loading);
const cancelText = computed(() =>
	notification.value?.textCancel
		? notification.value.textCancel
		: !notification.value?.read
		? "Rechazar"
		: "Cancelar"
);

// Methods
function handleActions(str: string) {
	const [action, payload] = str.split("/");
	cancel.value = action === "read";
	if (!loading.value) NotificationModule.handleAction({ action, payload });
}
function onClickCancel() {
	if (notification.value?.handleClose)
		return notification.value.handleClose() && handleClose();
	!notification.value?.read ? handleActions("read") : handleClose();
}
function handleClose() {
	!notification.value?.button
		? handleActions("read")
		: NotificationModule.show(false);
}

// watchs
watch(
	() => NotificationModule.loading,
	(isLoading, wasLoading) => {
		if (!isLoading && wasLoading) NotificationModule.show(false);
	}
);

return (_ctx: any,_cache: any) => {
  const _component_base_button = _resolveComponent("base-button")!

  return (_unref(notification))
    ? (_openBlock(), _createBlock(Modal, {
        key: 0,
        show: _unref(show) && _unref(notification) ? true : false,
        onClose: handleClose,
        "modal-classes": `modal-${_unref(notification).type ?? 'secondary'}`,
        "body-classes": "py-0",
        style: {"animation-duration":"0.3s"},
        "modal-content-classes": `bg-gradient-${_unref(notification).type ?? 'secondary'}`
      }, {
        header: _withCtx(() => [
          _createElementVNode("h4", _hoisted_1, _toDisplayString(_unref(notification).title), 1)
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            (_unref(notification).button)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_base_button, {
                    link: "",
                    loading: _unref(loading) && cancel.value,
                    onClickCapture: _withModifiers(onClickCancel, ["stop"])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(cancelText)), 1)
                    ]),
                    _: 1
                  }, 8, ["loading", "onClickCapture"]),
                  _createVNode(_component_base_button, {
                    type: _unref(notification).type === 'secondary' ? 'primary' : 'secondary',
                    "native-type": "submit",
                    class: "ml-auto",
                    loading: _unref(loading) && !cancel.value,
                    onClickCapture: _cache[0] || (_cache[0] = _withModifiers(
							() =>
								_unref(notification)?.action
									? handleActions(_unref(notification)?.action)
									: _unref(notification)?.handleAction?.() && handleClose()
						, ["stop"]))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        class: _normalizeClass(`text-${_unref(notification).type}`)
                      }, [
                        _createTextVNode(_toDisplayString(_unref(notification).textBtn ?? "Aceptar") + " ", 1),
                        (_unref(notification).rightIconBtn)
                          ? (_openBlock(), _createElementBlock("i", {
                              key: 0,
                              class: _normalizeClass(_unref(notification).rightIconBtn)
                            }, null, 2))
                          : _createCommentVNode("", true)
                      ], 2)
                    ]),
                    _: 1
                  }, 8, ["type", "loading"])
                ], 64))
              : (_openBlock(), _createBlock(_component_base_button, {
                  key: 1,
                  type: _unref(notification).type ?? 'secondary',
                  "native-type": "submit",
                  class: "ml-auto",
                  loading: _unref(loading) && cancel.value,
                  onClickCapture: _cache[1] || (_cache[1] = _withModifiers(
							() => handleActions(_unref(notification)?.action ?? 'read')
						, ["stop"]))
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["type", "loading"]))
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", {
              class: _normalizeClass(["avatar avatar-sm rounded-circle mt-3", {
					'no-background': !((_unref(notification).icon?.indexOf('http') ?? -1) > -1),
				}]),
              style: {"color":"inherit"}
            }, [
              ((_unref(notification).icon?.indexOf('http') ?? -1) > -1)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    style: {"width":"80px","height":"80px"},
                    alt: "Image placeholder",
                    src: _unref(notification).icon
                  }, null, 8, _hoisted_3))
                : (_openBlock(), _createElementBlock("i", {
                    key: 1,
                    style: {"font-size":"3rem"},
                    class: _normalizeClass(_unref(notification).icon ?? 'fas fa-bell')
                  }, null, 2))
            ], 2),
            _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(notification).description), 1)
          ])
        ]),
        _: 1
      }, 8, ["show", "modal-classes", "modal-content-classes"]))
    : _createCommentVNode("", true)
}
}

})